import React, { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { Company } from "../utils/companyUtils";

interface MeetingPointsMarkersProps {
  meetingPoints: Company[];
  onCompanyClick?: (company: Company) => void;
}

const MeetingPointsMarkers: React.FC<MeetingPointsMarkersProps> = ({
  meetingPoints,
  onCompanyClick,
}) => {
  const map = useMap();
  const markersRef = useRef<any[]>([]);

  useEffect(() => {
    // Always show meeting points, regardless of other settings
    if (!meetingPoints || meetingPoints.length === 0) {
      return;
    }

    console.log("📍 Adding meeting points markers:", meetingPoints.length);

    // Clear existing markers
    markersRef.current.forEach((marker) => map.removeLayer(marker));
    markersRef.current = [];

    meetingPoints.forEach((meetingPoint) => {
      const marker = (L as any).marker(
        [meetingPoint.coordinates[1], meetingPoint.coordinates[0]],
        {
          zIndexOffset: -200,
          icon: (L as any).divIcon({
            className: "meeting-point-marker",
            html: `<div style="
              background-color: #34A936;
              width: 14px;
              height: 14px;
              border-radius: 50%;
              border: 2px solid white;
              box-shadow: 0 2px 6px rgba(0,0,0,0.4);
            "></div>`,
            iconSize: [14, 14],
            iconAnchor: [7, 7],
          }),
        }
      );

      marker.bindPopup(`
        <div>
          <h4>${meetingPoint.name}</h4>
          <p><strong>Address:</strong> ${meetingPoint.address}</p>
          <p><strong>Region:</strong> ${meetingPoint.region || "Unknown"}</p>
        </div>
      `);

      marker.on("click", () => {
        if (onCompanyClick) {
          onCompanyClick(meetingPoint);
        }
      });

      marker.addTo(map);
      markersRef.current.push(marker);
    });

    return () => {
      markersRef.current.forEach((marker) => map.removeLayer(marker));
      markersRef.current = [];
    };
  }, [map, meetingPoints, onCompanyClick]);

  return null;
};

export default MeetingPointsMarkers;

